import { render } from "./MakeSalePage.vue?vue&type=template&id=35ec6c79&scoped=true"
import script from "./MakeSalePage.vue?vue&type=script&lang=js"
export * from "./MakeSalePage.vue?vue&type=script&lang=js"

import "./MakeSalePage.vue?vue&type=style&index=0&id=35ec6c79&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ec6c79"]])

export default __exports__